export class Hotspot {
  private trigger: NodeListOf<Element>;
  private clickOutsideHandler: (event: Event) => void;

  constructor() {
    this.trigger = document.querySelectorAll('[data-hotspots-image-trigger]');
    this.trigger.forEach((item: Element) => {
      item.addEventListener('click', () => {
        let key = item.getAttribute('data-hotspots-image-trigger'),
            scope = item.getAttribute('data-hotspots-image-scope'),
            icon = document.querySelector('[data-hotspots-image-icon="' + key + '"]'),
            target = document.querySelector('[data-hotspots-image-target="' + key + '"]'),
            indicator = document.querySelector('[data-hotspots-image-indicator="' + key + '"]'),
            alreadyActive = false;
        if (icon?.classList.contains('is-active') && target?.classList.contains('is-visible')) {
          alreadyActive = true;
        }
        this.closeAllInScope(scope!);
        if (!alreadyActive) {
          target?.classList.add('is-visible');
          indicator?.classList.add('is-visible');
          icon?.classList.add('is-active');
        }
      });
    });
    this.clickOutsideHandler = this.handleClickOutside.bind(this);
    document.addEventListener('click', this.clickOutsideHandler, false);
  }

  closeAllInScope(scope: string) {
    let scopeIcons = document.querySelectorAll('[data-hotspots-image="' + scope + '"] [data-hotspots-image-icon]'),
        scopeIndicators = document.querySelectorAll('[data-hotspots-image="' + scope + '"] [data-hotspots-image-indicator]'),
        scopeTargets = document.querySelectorAll('[data-hotspots-image="' + scope + '"] [data-hotspots-image-target]');
    scopeTargets.forEach((item: Element) => {
      item.classList.remove('is-visible');
    });
    scopeIndicators.forEach((item: Element) => {
      item.classList.remove('is-visible');
    });
    scopeIcons.forEach((item: Element) => {
      item.classList.remove('is-active');
    });
  }

  closeAll() {
    let icons = document.querySelectorAll('[data-hotspots-image-icon]'),
        indicators = document.querySelectorAll('[data-hotspots-image-indicator]'),
        targets = document.querySelectorAll('[data-hotspots-image-target]');
    targets.forEach((item: Element) => {
      item.classList.remove('is-visible');
    });
    indicators.forEach((item: Element) => {
      item.classList.remove('is-visible');
    });
    icons.forEach((item: Element) => {
      item.classList.remove('is-active');
    });
  }

  handleClickOutside(event: Event) {
    let parents = document.querySelectorAll('[data-hotspots-image-target],[data-hotspots-image-trigger]');
    let isInside = false;
    parents.forEach((element: Element) => {
      if (element.contains(event.target as Node)) {
        isInside = true;
      }
    });
    if (!isInside) {
      this.closeAll();
    }
  }
}

// The ready event handler and self cleanup method
function hotspot_completed() {
  document.removeEventListener("DOMContentLoaded", hotspot_completed);
  new Hotspot();
}

if (document.readyState === "complete" ||
    (document.readyState !== "loading")) {
  hotspot_completed();
} else {
  document.addEventListener("DOMContentLoaded", hotspot_completed);
}
